import { Component, inject, OnInit, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { HeaderComponent } from '../header/header';
import { MenuItem } from '../../core/models/interfaces-general';
import { FooterComponent } from '../components/footer.component';
import { CategoriaService } from '../../core/services/categoria.service';
import { EmpresaService } from '../../core/services/empresa.service';
import { CategoriaMapper } from '../../core/mappers/categoria.mapper';
import { WhatsappUtility } from '../../core/utility/whatsapp-utility';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-layout-base',
    imports: [
        CommonModule,
        RouterOutlet,
        HeaderComponent,
        FooterComponent
    ],
    templateUrl: './layoutBase.html',
    styles: ''
})
export class LayoutBaseComponent implements OnInit {
    private categoriaService = inject(CategoriaService);
    private empresaService = inject(EmpresaService);

    logoUrl = signal('https://undetalle.com.pe/wp-content/uploads/2025/11/2212f1a8128bbb7b77ac4c41ea233e62fcaf5bd8.png');
    menu = signal<MenuItem[]>([]);
    cartCount = signal(0);
    whatsapp = signal('');

    ngOnInit(): void {
        this.empresaService.getEmpresa().subscribe({
            next: (e) => this.whatsapp.set((e?.whatsapp ?? '').replace(/\D/g, '')),
            error: () => undefined
        });

        this.categoriaService.listCategorias().subscribe({
            next: (categorias) => {
                const items = CategoriaMapper.toMenu(categorias);
                if (items.length > 0) {
                    this.menu.set(items);
                }
            }
        });

        this.empresaService.getEmpresa().subscribe({
            next: (empresa) => {
                if (empresa?.urlLogo) {
                    this.logoUrl.set(empresa.urlLogo);
                }
            }
        });
    }
    whatsappLink(): string {
        return WhatsappUtility.waLink(this.whatsapp(), '¡Hola vengo a través de la tienda virtual!');
    }

}
